// extracted by mini-css-extract-plugin
export default {"wrapper":"Po-z","response":"Qo-z","error":"Ro-z","disabled":"So-z","buttons":"To-z","feedbackQuestionSection":"Uo-z","yesNoWrapper":"Vo-z"};